handleCheckoutV2OrderResponse